import React from "react";
import { Route, Redirect } from "react-router-dom";

const AuthenticatedRoute = ({ path, component, authenticated, exact }) => (
    authenticated ?
        <Route path={path} component={component} exact={exact} />
            : <Redirect to="/login" />
)

export default AuthenticatedRoute;
